// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustodialPlan } from './CustodialPlan';
import { CustomEvent } from '@shared/utils/CustomEvents';
export class CustodialPlans {
    constructor() {
        this.UpdateEvent = new CustomEvent();
        this._fCustodialPlans = {};
    }
    GetPlanById(id) {
        var _a;
        return (_a = this._fCustodialPlans[id]) !== null && _a !== void 0 ? _a : null;
    }
    Add(message) {
        let plan = this.GetPlanById(message.Id);
        if (isNullOrUndefined(plan)) {
            plan = this._fCustodialPlans[message.Id] = new CustodialPlan(message.Id);
        }
        plan.Update(message);
        this.UpdateEvent.Raise(plan);
    }
    GetCustodialDataByInstrument(planId, instr) {
        if (instr === null || planId === null) {
            return null;
        }
        const plan = this.GetPlanById(planId);
        return plan != null && !plan.IsZero() ? plan.GetData(instr) : null;
    }
    Clear() {
        this._fCustodialPlans = {};
    }
}
